"use strict";

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var hasNoWindow = typeof window === "undefined";
var root = hasNoWindow ? global : window;

// ---------------------------------------------------
// Module Definition
module.exports = function () {};

/* develblock:start */
// THIS IS ONLY AN ISSUE IN `DEVELOPMENT` MODE

// but still have to fix this for fucking IE9...
// shit bags define console functions as
// fucking objects...WHAT.THE.FUCK?!?!?
if (!root.console) {
    // just make sure the console exists
    root.console = {};
}
if (!root.console.assert || typeof root.console.assert === 'object') {
    // in fucking IE9 (or various broken implementations)
    // or do we just let it fail? just apply a no op
    root.console.assert = function () {};
}
/**
 * @module assert
 * @type {function}
 * @param {boolean} condition Condition to test
 * @param {string} failureMessage Error message to display if condition is falsy
 */
module.exports = hasNoWindow ? require('assert').ok : _.bind(root.console.assert, root.console);
/* develblock:end */



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/assert.js
// module id = 31
// module chunks = 62